import {AlertController } from 'ionic-angular';

export class BasePage {

    constructor( protected alertCtrl : AlertController ) {
        // Constructor
    }


    // Helper methods
    displayConfirmation( title: string, message: string, callback: any) : Promise<any> {
        return this.alertCtrl.create( {
            title: title,
            subTitle: message,
            buttons: [
                {
                    text: 'Disagree'
                },
                {
                    text: 'Agree',
                    handler: callback
                }
            ]
        }).present();        
    }

    displayAlert( title: string, message: string ) {
        return this.alertCtrl.create( {
            title: title,
            subTitle: message,
            buttons: ['OK']
        }).present();
    }

    displayError( message: string) : Promise<any> {
        return this.alertCtrl.create( {
            title: 'Unexpected Error',
            subTitle: message,
            buttons: ['Dismiss']
        }).present();
    }    
    
}


// WEBPACK FOOTER //
// ./src/pages/base.component.ts